import objectToXeditId from "./objectToXeditId";

export default function objectToContainerId(obj) {
    return objectToXeditId(obj)
}